import React from "react";
import "../../styles/saving.scss";


import { Link, Route, RouteComponentProps, withRouter } from "react-router-dom";
import { SavingDetial } from "./SavingDetial";
import { Search } from "../components/Search";
import { Pager } from "../components/Pager";
import { getCollections } from "../../apis/api";
import { CollectionInfo, pageInfo } from "../../models/system";





//@ts-ignore
@withRouter
export class SavingType extends React.Component<Partial<RouteComponentProps<{ id: string }>>>{
    state = { data: null as pageInfo<CollectionInfo> | null, current: 0 as number, pagecount: 0 as number, pageSize: 8 as number }
    async componentDidMount() {
        let child = document.querySelector("#submenu")!.children;
        for (let i = 0; i < child.length; i++) {
            child[i].classList.remove("choiced");
        }
        var id = parseInt(this.props.match!.params.id);

        document.querySelector("#submenu")!.children[id].classList.add("choiced");
        let x = await getCollections(id, this.state.current, 8);
        this.setState({ data: x, pagecount: x.pageCount });

        document.querySelectorAll(".listitem").forEach((x, idx) => {
            x.addEventListener("click", () => {
                document.location.href = idx.toString();
            });
        });

    }


    render() {



        return (
            <section className="savingtype headerinfo info bg">



                <nav className="submenu" id="submenu">
                    <div className="listitem choiced"><span>铜器</span></div>
                    <div className="listitem"><span>玉石器</span></div>
                    <div className="listitem"><span>陶瓷器</span></div>
                    <div className="listitem"><span>书画</span></div>
                    <div className="listitem"><span>金银器</span></div>
                    <div className="listitem"><span>其他</span></div>


                </nav>
                <div className="savingitems">

                    {
                        this.state.data?.content?.map((x, idx) => {

                            return (
                                <>
                                    <div>
                                        <Link to={`../savingdetial/${x.id}`}>
                                            <img src={x.pic} alt={x.pic} />
                                            <div>{x.title}</div>
                                        </Link>

                                    </div>
                                </>
                            )
                        })
                    }



                </div>

                <Pager pageCount={Math.ceil(this.state.pagecount / this.state.pageSize)} pageSize={10} curpage={this.state.current} onNavigatePage={async (e) => {
                    this.setState({ current: e });
                    var id = parseInt(this.props.match!.params.id);
                    let x = await getCollections(id, e, this.state.pageSize);

                    this.setState({ data: x });
                }}></Pager>
            </section >
        )
    }
}


